import { DraftSaveState } from './draftSaveStatus.types';
import {
  DraftSaveStatusAction,
  SET_AUTO_SAVE_STATUS,
  SET_MANUAL_SYNC_STATUS,
  SET_FORM_DIRTY,
  RESET_SAVE_STATUS
} from './draftSaveStatus.action';

const initialState: DraftSaveState = {
  autoSaveStatus: 'idle',
  manualSyncStatus: 'idle',
  isFormDirty: false
};

export const draftSaveStatusReducer = (
  state: DraftSaveState = initialState,
  action: DraftSaveStatusAction
): DraftSaveState => {
  switch (action.type) {
    case SET_AUTO_SAVE_STATUS:
      return { ...state, autoSaveStatus: action.payload.status };
    case SET_MANUAL_SYNC_STATUS:
      return { ...state, manualSyncStatus: action.payload.status };
    case SET_FORM_DIRTY:
      return { ...state, isFormDirty: action.payload.dirty };
    case RESET_SAVE_STATUS:
      return initialState;
    default:
      return state;
  }
};

export default draftSaveStatusReducer;
